import React, { useState, useEffect } from "react";
import { numberFormatter } from "../../utils";

const AnalysisOutput = (props: any) => {
	const [tableData, setTableData] = useState([]);

	useEffect(() => {
		if (props.attributeData?.data?.final_dict) {
			let high: any[] = [];
			let medium: any[] = [];
			let low: any[] = [];
			props.attributeData?.data?.final_dict.map(
				(item: any, index: any) => {
					if (item.RelevenceScore === "High") {
						high.push(item);
					} else if (item.RelevenceScore === "Medium") {
						medium.push(item);
					} else {
						low.push(item);
					}
				}
			);
			let sortedData: any = [...high, ...medium, ...low];
			setTableData(sortedData);
		}
	}, [props]);

	return (
		<>
			<div className="w-full pl-4 ">
				<h1 className="text-[2.5vh] font-bold text-black h-[6vh]">
					Output
				</h1>
				<p className="text-[2vh] text-black">
					A model accuracy of 70% is recommended to effectively
					pinpoint SKUs that present opportunities for cost reduction
				</p>
			</div>
			{/* <span className="italic">Parametric Equation</span>
      <div className="flex basis-[15%] bg-[gray] mx-[1vh]"></div> */}
			<div className="flex gap-4 mx-[2vh] my-[0.5vh]">
				<div className="customcard flex flex-col items-start  p-[1vh] rounded-sm">
					<span className="font-bold text-[1.5vh] text-[#666]">
						Model Accuracy
					</span>

					<div className="px-[1vh] py-[1vh] font-bold italic text-black w-[8vw] ">
						{props.attributeData.modelAccuracy}%
					</div>
				</div>

				<div className="customcard flex flex-col items-start  p-[1vh] rounded-sm">
					<span className="font-bold text-[1.5vh] text-[#666]">
						Relevant Attributes
					</span>

					<div className="px-[1vh] py-[1vh] font-bold italic text-black w-[8vw] ">
						{props.attributeData.noOfAttributes}
					</div>
				</div>

				<div className="customcard flex flex-col items-start  p-[1vh] rounded-sm">
					<span className="font-bold text-[1.5vh] text-[#666]">
						Total Opportunity
					</span>

					<div className="px-[1vh] py-[1vh] font-bold italic text-black w-[8vw] ">
						{numberFormatter(
							props.attributeData.totalOpportunity,

							0,

							"$"
						)}
					</div>
				</div>
			</div>

			<div className="flex basis-[50%] mx-[1vh] bg-white justify-center">
				<div className="supplyingTable bg-white">
					<div className="tableHeader">
						<div className="tableheadRow">
							<div className="tableCell">Selected Attributes</div>
							<div className="tableCell">
								Relationship with Cost
							</div>
							<div className="tableCell">
								Attribute Relevance Score
							</div>
						</div>
					</div>
					<div className="tableBody">
						{Array.isArray(tableData) &&
							tableData?.map((d: any, index: any) => {
								return d.selected ? (
									<div
										className="tableRow"
										key={index + d.Attribute}
									>
										<div className="tableCell">
											{d.Attribute === "China"
												? "Country of Origin: China"
												: d.Attribute ===
												  "SnapIn_Cable_Connector"
												? "Type: SnapIn Cable Connector"
												: d.Attribute ===
												  "Duplex_Cable_Connector"
												? "Type: Duplex Cable Connector"
												: d.Attribute ===
												  "45_Degree_Configuration"
												? "Configuration: 45 degree"
												: d.Attribute.replaceAll(
														"_",
														" "
												  )}
										</div>
										<div className="tableCell">
											{d.RelationshipWithCost}
										</div>
										<div className="tableCell">
											{d.RelevenceScore}
										</div>
									</div>
								) : (
									""
								);
							})}
					</div>
				</div>
			</div>
		</>
	);
};
export default AnalysisOutput;
